'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _colors = require('HubStyleTokens/colors');

var _PageConstants = require('./PageConstants');

var _UIAbstractPageGridContent = require('./UIAbstractPageGridContent');

var _UIAbstractPageGridContent2 = _interopRequireDefault(_UIAbstractPageGridContent);

var _UIAbstractPageSection = require('./UIAbstractPageSection');

var _UIAbstractPageSection2 = _interopRequireDefault(_UIAbstractPageSection);

var _UIPage = require('./UIPage');

var _UIPage2 = _interopRequireDefault(_UIPage);

var _UIHeader = require('../layout/UIHeader');

var _UIHeader2 = _interopRequireDefault(_UIHeader);

var _customRenderer = require('../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _NavHeight = require('../utils/NavHeight');

var _Styles = require('../utils/Styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function mainWrapperBackgroundColor(color) {
  return {
    backgroundColor: color
  };
}

function renderHeader(headerComponent, headerUse, alertComponent, title) {
  var headerOptions = {
    title: title,
    use: headerUse
  };

  if (alertComponent) {
    headerOptions = _extends({
      alert: alertComponent
    }, headerOptions);
  }

  return CustomRenderer.render(headerComponent, headerOptions);
}

function getBodyClassNames(bodyClassName, pageLayout) {
  return (0, _classNames2.default)('space-sword', bodyClassName, {
    'space-sword--max-width': pageLayout === 'max-width'
  });
}

var StyledPage = (0, _styledComponents2.default)(function (props) {
  var __navHeight = props.navHeight,
      rest = _objectWithoutProperties(props, ['navHeight']);

  return _react2.default.createElement(_UIPage2.default, rest);
}).withConfig({
  displayName: 'UIAbstractPageTemplate__StyledPage'
})(['display:flex;flex-direction:column;flex-grow:1;background-color:', ';min-height:calc(100vh - ', ');'], _colors.OLAF, function (_ref) {
  var navHeight = _ref.navHeight;
  return (0, _Styles.toPx)(navHeight);
});

function UIAbstractPageTemplate(_ref2) {
  var alertComponent = _ref2.alertComponent,
      asDevice = _ref2.asDevice,
      bodyClassName = _ref2.bodyClassName,
      children = _ref2.children,
      className = _ref2.className,
      contentAreaFlush = _ref2.contentAreaFlush,
      headerComponent = _ref2.headerComponent,
      horizontalDivider = _ref2.horizontalDivider,
      narrowLayout = _ref2.narrowLayout,
      MainSection = _ref2.MainSection,
      mainSectionBackgroundColor = _ref2.mainSectionBackgroundColor,
      mainSectionStyle = _ref2.mainSectionStyle,
      navHeight = _ref2.navHeight,
      pageBackgroundColor = _ref2.pageBackgroundColor,
      pageLayout = _ref2.pageLayout,
      pageMaxWidth = _ref2.pageMaxWidth,
      pageStyle = _ref2.pageStyle,
      sidebarComponent = _ref2.sidebarComponent,
      stickySidebar = _ref2.stickySidebar,
      tabs = _ref2.tabs,
      title = _ref2.title,
      rest = _objectWithoutProperties(_ref2, ['alertComponent', 'asDevice', 'bodyClassName', 'children', 'className', 'contentAreaFlush', 'headerComponent', 'horizontalDivider', 'narrowLayout', 'MainSection', 'mainSectionBackgroundColor', 'mainSectionStyle', 'navHeight', 'pageBackgroundColor', 'pageLayout', 'pageMaxWidth', 'pageStyle', 'sidebarComponent', 'stickySidebar', 'tabs', 'title']);

  var headerUse = tabs ? 'condensed' : undefined;

  var headerWrapperClassNames = (0, _classNames2.default)('private-template__section--header');

  var mainWrapperClassNames = (0, _classNames2.default)('private-template__section--stretch', {
    'private-template__section--divided': horizontalDivider,
    'private-template--narrow': narrowLayout
  });

  var pageClassName = (0, _classNames2.default)('private-template', _PageConstants.DEVICE_CLASSES[asDevice], _PageConstants.LAYOUT_CLASSES[pageLayout], className);

  var sectionClassNames = (0, _classNames2.default)({
    'private-template__section--spaced-vertical': !contentAreaFlush,
    'private-template__section--flush': contentAreaFlush
  });

  var templateBackgroundColor = function templateBackgroundColor(color) {
    return {
      backgroundColor: color
    };
  };

  var templateMaxWidth = function templateMaxWidth(width) {
    if (!width) return null;

    return {
      maxWidth: width
    };
  };

  return _react2.default.createElement(
    'div',
    { className: 'private-ie11-flex-wrapper' },
    _react2.default.createElement(
      StyledPage,
      _extends({}, rest, {
        bodyClassName: getBodyClassNames(bodyClassName, pageLayout),
        className: pageClassName,
        navHeight: (0, _lazyEval2.default)(navHeight),
        style: _extends({}, templateBackgroundColor(pageBackgroundColor), pageStyle)
      }),
      _react2.default.createElement(
        _UIAbstractPageSection2.default,
        {
          className: headerWrapperClassNames,
          style: _extends({}, templateMaxWidth(pageMaxWidth))
        },
        renderHeader(headerComponent, headerUse, alertComponent, title),
        tabs
      ),
      _react2.default.createElement(
        'div',
        {
          className: mainWrapperClassNames,
          style: _extends({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
        },
        _react2.default.createElement(
          _UIAbstractPageSection2.default,
          {
            className: sectionClassNames,
            style: _extends({}, templateMaxWidth(pageMaxWidth))
          },
          _react2.default.createElement(
            MainSection,
            {
              sidebarComponent: sidebarComponent,
              stickySidebar: stickySidebar,
              style: _extends({}, mainWrapperBackgroundColor(mainSectionBackgroundColor), mainSectionStyle)
            },
            children
          )
        )
      )
    )
  );
}

var alertDeprecationMsg = {
  key: 'UIAbstractPageTemplate: alert deprecated',
  message: 'Page template: passing both a custom headerComponent and alertComponent can lead ' + 'to unexpected results. Include the alert(s) directly in the headerComponent content ' + 'for more predictable output.\n' + 'For more details, see: https://git.hubteam.com/HubSpot/UIComponents/issues/3934'
};

var getAlertDeprecation = function getAlertDeprecation(name, value) {
  var allProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var header = allProps.headerComponent;
  var hasSafeHeader = value == null || header == null || typeof header === 'function' || _react2.default.isValidElement(header) && header.type === _UIHeader2.default;

  return !hasSafeHeader ? alertDeprecationMsg : null;
};

UIAbstractPageTemplate.propTypes = {
  alertComponent: (0, _deprecated2.default)(_react.PropTypes.node, getAlertDeprecation),
  asDevice: _react.PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
  bodyClassName: _react.PropTypes.string,
  children: _react.PropTypes.node.isRequired,
  contentAreaFlush: _react.PropTypes.bool.isRequired,
  horizontalDivider: _react.PropTypes.bool.isRequired,
  headerComponent: CustomRenderer.propType,
  MainSection: _component2.default,
  mainSectionBackgroundColor: _react.PropTypes.string,
  mainSectionComponent: CustomRenderer.propType,
  mainSectionStyle: _react.PropTypes.object,
  narrowLayout: _react.PropTypes.bool.isRequired,
  navHeight: (0, _createLazyPropType2.default)(_react.PropTypes.number).isRequired,
  pageBackgroundColor: _react.PropTypes.string,
  pageLayout: _react.PropTypes.oneOf(Object.keys(_PageConstants.LAYOUT_CLASSES)),
  pageMaxWidth: _react.PropTypes.number,
  pageStyle: _react.PropTypes.object,
  sidebarComponent: CustomRenderer.propType,
  stickySidebar: _react.PropTypes.bool,
  tabs: _react.PropTypes.node,
  title: _react.PropTypes.node
};

UIAbstractPageTemplate.defaultProps = {
  contentAreaFlush: false,
  headerComponent: _UIHeader2.default,
  horizontalDivider: false,
  MainSection: _UIAbstractPageGridContent2.default,
  narrowLayout: false,
  navHeight: _NavHeight.getDefaultNavHeight,
  pageLayout: 'max-width',
  stickySidebar: false
};

UIAbstractPageTemplate.displayName = 'UIAbstractPageTemplate';

exports.default = UIAbstractPageTemplate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/page/UIAbstractPageTemplate.js
// module id = 595
// module chunks = 171